export const images = {
  hero: "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533508989_ffebadf6.webp",

  focusAreas: {
    ai: "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533510694_445b5bb7.webp",
    farming:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533513579_cef517c2.webp",
    stem: "/images/Hero2.jpeg",
  },

  team: [
    "/profiles/Danso.jpeg",
    "/profiles/Samuel.jpeg",
    "/profiles/Agyapomaa.jpeg",
    "/profiles/Janet.jpeg",
    "/profiles/Farida.jpeg",
    "/profiles/Julian.jpeg",
    "/profiles/Serwaa.jpeg",
    "/profiles/Joana.jpeg",
    "/profiles/Keneth.jpeg",
    "/profiles/Baffour.jpeg",
    "/profiles/Reginald.jpeg",
    "/profiles/Prosper.jpeg",
    "/profiles/Josephine.jpeg",
    "/profiles/Afia.jpeg",
    "/profiles/Turkson.jpeg",
    "/profiles/Sefah.jpeg",
    "/profiles/Loretta.jpeg",
    "/profiles/Esi.jpeg",
    "/profiles/Anita.jpeg",
    "/profiles/Wisdom.jpeg",
    "/profiles/Christabel.jpeg",
    "/profiles/Boatey.jpeg",
    "/profiles/Achiaa.jpeg",
    "/profiles/Charlotte.jpeg",
    "/profiles/Mary.jpeg",
    "/profiles/Mohammed.jpeg",
    "/profiles/Ruqyah.jpeg",
    "/profiles/Agyeiwaa.jpeg",
    "/profiles/Sylvester.jpeg",
  ],

  services: {
    software:
      "/images/Hero6.jpeg",
    ai:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533533907_21ff5ddf.webp",
    drones:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533538815_cb528c74.webp",
    hydroponics:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533548732_57c25643.webp",
    robotics:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533549722_4069094b.webp",
    coding:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533551383_cd6ee1bf.webp",
    outreach:
      "https://d64gsuwffb70l.cloudfront.net/68ef9b8a3c6c06c01749face_1760533552165_730441c4.webp",
  },

  blog: [
    "/events/event8.jpeg",
    "/events/event7.jpeg",
    "/events/event6.jpeg",
    "/events/event5.jpeg",
    "/events/event4.jpeg",
    "/events/event3.jpeg",
    "/events/event2.jpeg",
    "/events/event1.png",
    // "/events/event.jpeg",
  ],
};
